<template>
  <div class="content">
    <!-- <img :src="apiData.banner.data" width="100%" height="100%" style="display: block;"> -->

    <img v-if="parentID != 167" :src="guidanceList.slideShow" width="100%" style="display: block;" />
    <img v-else src="https://cgp-resource.oss-cn-beijing.aliyuncs.com/Images/UserHeadPict/20210202/124a0fcca22030f6892512786946252a.png" alt="" width="100%" />
    <breadcrumbPage :search-tag="false" :bg-color="'#fff'"></breadcrumbPage>
    <div class="bgBar" v-if="guidanceList.contents != ''">
      <div class="EC_width display_between">
        <div style="background:url('/image/information/shu1.png') ; width: 89px; height: 127px; color: #fff; font-weight:bold; 
               font-size: 22px; writing-mode: vertical-lr;">
          <div style="margin:20px 28px 0; letter-spacing:1em;line-height:13pt">
            导读
          </div>
        </div>
        <!-- <img src="/image/information/shu1.png"> -->
        <div class="flex1 marginLeft30">
          <p style="line-height: 30px;">
            <span v-html="guidanceList.contents"></span>
          </p>
        </div>
      </div>
    </div>
    <div class="EC_width">
      <div class="gl_title_bar marginBottom20 marginTop40">
        <div class="gl_tb_left">
          <span class="normaltitle marginRight10" v-if="parentID != 167">
            专题
          </span>
          <span class="normaltitle marginRight10" v-else>专家服务中心</span>
          <span class="grayColor">{{ c_name }}</span>
        </div>
      </div>
      <div class="display_flex">
        <div class="marginRight30">
          <ul class="pubL_menu">
            <li :class="{ pubL_menu_active: meunTagIndex == index }" v-for="(item, index) in selColumnList" :key="index" @click="menuTag(index, item)">
              <a href="javascript:;">
                {{ item.name }}
              </a>
              <div class="arrtig"></div>
            </li>
          </ul>
        </div>
        <div class="flex1">
          <div v-if="pageCount > 0">
            <div class="gl_listWrapBar" v-for="(item, index) in newsList" :key="'0' + index">
              <div class="gl_imgList" @click="specialclk(item)">
                <img v-if="parentID != 167" :src="item.slideShow" width="156" height="88" />
                <img v-else :src="item.slideShow" width="110" height="150" />
              </div>
              <a href="javascript:;" class="gl_listItem">
                <div class="gl_listItemTitle " :class="{ marginTop30: parentID == 167 }" @click="specialclk(item)">
                  {{ item.title }}
                </div>
                <div class="gl_listItemSub" @click="specialclk(item)">
                  {{ item.abstract }}
                </div>
                <div class="display_between marginTop10">
                  <div v-if="item.labelName != ''">
                    <span v-bind:class="calculate(index2)" v-for="(itemN, index2) in (item.labelName || '').split(',')" :key="'0' + index2" @click="onsearch(itemN)">
                      {{ itemN }}
                    </span>
                  </div>
                  <div v-else></div>
                  <div class="gl_inforshow">
                    <span class="marginRight20">
                      {{ formatTime(item.publishtime, 'YYYY/MM/DD') }}
                    </span>
                    <span>
                      <img src="/image/index/chakan.png" class="marginRight5" />
                      {{ item.clickVolume }}
                    </span>
                  </div>
                </div>
              </a>
            </div>
          </div>
          <div v-else style="text-align:center;">
            <strong>暂无数据</strong>
          </div>
          <!-- 分页器 -->
          <div class="pagination_Wrap" v-if="pageCount > 0" style="margin-top:10px;margin-bottom:10px">
            <pagination :total="pageCount" :limit="pageSize" :page="pageIndex" @page-change="pageChange"></pagination>
          </div>
        </div>
      </div>
    </div>

    <div style="padding: 40px 0;" v-if="isOpen">
      <div class="EC_width">
        <div class="gl_title_bar marginBottom20">
          <div class="gl_tb_left ctop">
            <span class="normaltitle marginRight10">{{title}}</span>
            <div v-for="(item,index) in labelList" :key="index" :class="labelType == item.id ? 'ctopbq1' : 'ctopbq'" @click="tobiaoqian(item.id, item.name)">{{item.name}}</div>
          </div>
        </div>
        <div class="positionBtn" v-if="kechengList.length> 0">
          <swiper :options="swiperOption2" ref="mySwiper" class="imgBanner">
            <swiper-slide style="text-align: center" v-for="(item, index) in kechengList" :key="'3' + index">
              <a href="javascript:;" class="en_swiperImg" @click="tokecheng(item.id)" style="cursor: pointer;">
                <img :src="item.acr_PictResUrl" width="285" height="169" />
                <div class="marginTop20">
                  {{ item.title }}
                </div>
              </a>
            </swiper-slide>
          </swiper>
          <div class="prevbutton2">&lt;</div>
          <div class="nextbutton2">&gt;</div>
        </div>

        <div class="cmid" v-if="kechengList.length == 0">
          <p style="width:100%;text-align: center;">暂无课程</p>
        </div>
      </div>
    </div>

    <div class="bgBar">
      <div class="EC_width">
        <div class="gl_title_bar marginBottom20">
          <div class="gl_tb_left">
            <span class="normaltitle marginRight10">更多专题</span>
          </div>
        </div>
        <div class="positionBtn">
          <swiper :options="swiperOption" ref="mySwiper" class="imgBanner">
            <swiper-slide style="text-align: center" v-for="(item, index) in speciRecommeData" :key="'3' + index">
              <a href="javascript:;" class="en_swiperImg" @click="clickSpecial(item)">
                <img :src="item.slideShow" width="285" height="169" />
                <div class="marginTop20">
                  {{ item.title }}
                </div>
              </a>
            </swiper-slide>
          </swiper>
          <div class="prevbutton">&lt;</div>
          <div class="nextbutton">&gt;</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import breadcrumbPage from '../home/breadcrumbPage';
import format from '@/assets/unit/unit.js';
export default {
  name: 'specialHome',
  data() {
    return {
      //标签类别
      labelType: 0,
      labelList: [],//推荐标签
      isOpen: false,//是否打开
      title: '',//推荐课程标题
      kechengList: [],//课程list
      // 页数激活index
      pageIndex: 1,
      pageAll: 8,
      apiData: {
        banner: {},
        intro: {},
        list: {},
        moreSpecial: {},
      },
      swiperOption: {
        slidesPerView: 4,
        slidesPerGroup: 1,
        // 如果需要前进后退按钮
        navigation: {
          nextEl: '.nextbutton',
          prevEl: '.prevbutton',
          disabledClass: 'my-button-disabled',
        },
      },
      swiperOption2: {
        slidesPerView: 4,
        slidesPerGroup: 2,
        // 如果需要前进后退按钮
        navigation: {
          nextEl: '.nextbutton2',
          prevEl: '.prevbutton2',
          disabledClass: 'my-button-disabled',
        },
      },

      /**tianlianpei */
      meunTagIndex: 0,
      // 专题推荐
      speciRecommeData: [],
      parentID: 101,
      //栏目
      selColumnList: [],
      guidanceID: 0, //导读ID
      //导读信息
      guidanceList: {
        contents: '',
        title: '',
        slideShow: '',
      },
      specType: 0,
      //专题列表
      newsList: [],
      newCount: 0,
      currentPage: 1,
      pageSize: 6,
      selcolumnID: 0,
      c_name: '',
      pageCount: 0,
      colorList: ['gl_gree_block', 'gl_red_block', 'gl_blue_block'],
    };
  },
  created() {
    // this.getData()
    this.parentID = Number(this.$route.query.id);
    // 获取专题资讯数据
    this.GetNewsList();
    //获取栏目
    this.GetColumsInfoAllList();
    this.getSpecilCaseList();
    //获取推荐课程标签数据
    this.GetSpecialLabelRelation();
  },
  methods: {
    calculate(index) {
      var nm = this.colorList[Math.floor(index % 3)];
      return nm;
    },
    onsearch(keywords) {
      const { href } = this.$router.resolve({
        path: '/home/searchPage?',
        query: {
          labelname: keywords,
        },
      });
      window.open(href, '_blank');
    },
    menuTag(index, itemN) {
      this.pageCount = 0;
      this.pageIndex = 1;
      this.meunTagIndex = index;
      this.selcolumnID = itemN.id;
      this.newsList = [];
      this.GetData(itemN.id, 2);
    },
    /**点击分页事件 */
    pageChange(page) {
      if (document.body.scrollTop) {
        document.body.scrollTop = 0;
      }
      if (page == this.pageIndex) {
        return;
      }
      this.pageIndex = page;
      this.GetData(this.selcolumnID, 2);
    },

    /** tianlianpei */
    GetNewsList() {
      let _this = this;
      _this.newsList = [];
      _this.newCount = 0;
      if (_this.guidanceID != 0) {
        _this.GetData(_this.guidanceID, 1);
      }
      if (_this.selColumnList.length > 0) {
        _this.selcolumnID = _this.selColumnList[0].id;
        _this.GetData(_this.selColumnList[0].id, 2);
      }
      if (_this.selColumnList.length > 1) {
        _this.specType = 1;
      }
    },
    GetData(cid, type) {
      let _this = this;
      _this.$loading.show({
        text: 'loading',
        textStyle: {
          fontSize: '18px',
          color: '#f00',
        },
      });
      _this.httphelper
        .post('/api/NewApi/GetCorporateInfoPageList', {
          keyword: '',
          id: 0,
          parentID: 0,
          column_Type: Number(cid),
          pageIndex: _this.pageIndex,
          pageSize: _this.pageSize,
        })
        .then(res => {
          if (res.data.code == 200) {
            _this.$loading.hide();
            _this.newInfoViewsList = res.data.data;
            if (_this.newInfoViewsList != null && _this.newInfoViewsList.length > 0) {
              if (type == 1) {
                //导读
                _this.guidanceList = _this.newInfoViewsList[0];
              } else {
                _this.newsList = _this.newInfoViewsList;
                _this.pageCount = res.data.totalcount;
              }
            } else {
              _this.pageCount = 0;
            }
          }
        });
    },
    //根据专题父级id获取栏目信息
    GetColumsInfoAllList() {
      let _this = this;
      _this.httphelper
        .post('/api/NewApi/GetColumsInfoAllList', {
          cType: 2,
          isCHorEN: 1,
        })
        .then(res => {
          if (res.data.code == 200) {
            res.data.data.forEach(item => {
              if (item.parentid == this.parentID) {
                //一级菜单
                if (item.name == '导读') {
                  _this.guidanceID = item.id;
                } else {
                  _this.selColumnList.push(item);
                }
              }
              if (item.id == this.parentID) {
                _this.c_name = item.name;
                document.title = _this.c_name
              }
            });
            setTimeout(() => {
              _this.GetNewsList();
            }, 100);
          }
        });
    },
    //栏目的点击事件
    columnclk(item) {
      this.selcolumnID = item.id;
      this.GetData(item.id, 2);
    },
    specialclk(info) {
      //如果外连接存在，跳转外链，否则跳转详情
      if (Object.keys(info.address).length == 0) {
        const { href } = this.$router.resolve({
          path: '/home/specialDetails',
          query: {
            id: info.id,
            column_Type: this.selcolumnID,
          },
        });
        window.open(href, '_blank');
      } else {
        window.open(info.address, '_blank');
      }
    },
    //获取首页专题，全科病例数据
    getSpecilCaseList() {
      let _this = this;
      _this.httphelper
        .post('/api/NewApi/GetGpSiteNewInfoPageList', {
          keyword: '',
          id: 0,
          parentID: 0,
          column_Type: 47,
          pageIndex: 1,
          pageSize: 4,
        })
        .then(res => {
          res.data.data.gpSiteNewInfoViewsViews.forEach(item => {
            if (item.cid == 47) {
              _this.speciRecommeData.push(item);
            }
          });
        });
    },
    formatTime(datatime, timeformat) {
      return format(datatime, timeformat);
    },
    clickSpecial(info) {
      let urlstr = info.address;
      let param = urlstr.substr(urlstr.indexOf('?'), urlstr.length - urlstr.indexOf('?'));
      if (urlstr.search('specialRecomme') > -1) {
        const { href } = this.$router.resolve({
          path: '/home/specialRecomme' + param,
        });
        window.open(href, '_blank');
      } else if (urlstr.search('specialproject') > -1) {
        const { href } = this.$router.resolve({
          path: '/enterprise/qyhome' + param,
        });
        window.open(href, '_blank');
      } else {
        window.open(info.address, '_blank');
      }
    },
    /** 获取专题推荐标签 */
    GetSpecialLabelRelation() {
      let _this = this;
      _this.httphelper
        .post('/api/NewApi/GetSpecialLabelRelation', {
          specialId: this.parentID
        })
        .then(res => {
          if (res.data.code == 200 && res.data.data != null) {
            let data = res.data.data
            if (data.labelName != '') {
              let array1 = data.labelName.substring(1, data.labelName.length - 1).split(',')
              let array2 = data.labelgather.substring(1, data.labelgather.length - 1).split(',')
             
              let datalist = [];
              if (array2.length > 0) {
                _this.labelType = array2[0]
                array1.forEach((item, index) => {
                  datalist.push({ id: array2[index], name: array1[index] })
                })
                _this.getlist(array1[0]);
              }
              _this.labelList = datalist
            }
            _this.isOpen = data.isOpen
            _this.title = data.title
          }
        });
    },
    /**标签切换 */
    tobiaoqian(index, name) {
      if (this.labelType == index) return;
      this.labelType = index;
      this.getlist(name);
    },
    /** 根据标签获取推荐课程数据 */
    getlist(name) {
      this.httphelper
        .post('/api/NewApi/GetDbRecommendHomeCoursePageList', {
          labelName: name,
          number: 666
        })
        .then(res => {
          if (res.data.code == 200) {
            this.kechengList = res.data.data;
          }
        });
    },
    tokecheng(id) {
      window.open(this.httphelper.IsDebugCgphome() +'/detail?courseId=' + id)
    },
  },
  components: {
    breadcrumbPage,
  },
};
</script>

<style scoped>
.ctop {
    display: flex;
    align-items: center;
}
.ctopbq {
    padding: 7px 20px;
    line-height: 16px;
    border: 1px solid #eee;
    border-radius: 30px;
    margin-left: 5px;
    margin-top: -10px;
    cursor: pointer;
}
.ctopbq1 {
    padding: 7px 20px;
    line-height: 16px;
    border: 1px solid #eee;
    border-radius: 30px;
    margin-left: 5px;
    margin-top: -10px;
    background-color: #0b8686;
    color: #fff;
    cursor: pointer;
}
.content {
    flex: 1;
}

.bgBar {
    background: #f5f7fa;
    padding: 40px 0;
}

/* 底部左部菜单 */
/* 左边菜单部分 */
.pubL_menu {
    list-style: none;
    margin: 0;
    padding: 0;
}

.pubL_menu li {
    position: relative;
}

.pubL_menu li a {
    display: inline-block;
    height: 46px;
    width: 200px;
    text-align: center;
    box-sizing: border-box;
    line-height: 46px;
}

.pubL_menu a {
    background-color: #f1f2f4;
}

.arrtig {
    position: absolute;
    width: 0;
    height: 0;
    border: solid 8px;
    border-color: transparent transparent transparent #0b8686;
    right: -16px;
    top: 14px;
    display: none;
}

.pubL_menu_active a {
    background: #0b8686;
    color: #fff;
}

.pubL_menu_active .arrtig {
    display: block;
}

.positionBtn {
    margin-top: 20px;
    position: relative;
    width: 1240px;
}

.swiper-slide {
    text-align: center;
}

.en_swiperImg {
    display: inline-block;
    text-align: left;
    width: 285px;
}

/* 轮播按钮 */
.nextbutton,
.prevbutton,
.nextbutton2,
.prevbutton2 {
    display: inline-block;
    width: 30px;
    height: 30px;
    text-align: center;
    line-height: 30px;
    box-sizing: border-box;
    border-radius: 30px;
    background: #0b8586;
    color: #fff;
    position: absolute;
    top: 42%;
    z-index: 10;
    cursor: pointer;
    outline: none;
}

.nextbutton,
.nextbutton2 {
    right: -30px;
    left: auto;
}

.prevbutton,
.prevbutton2 {
    right: auto;
    left: -30px;
}

.my-button-disabled {
    background: #ddd;
    color: #999;
}
</style>
